'use client';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { logError } from 'commons/logger';

// Next.js navigation helpers (notFound, redirect, forbidden, unauthorized)
// throw errors tagged with these digest prefixes. Catching them here would
// swallow real 404/redirects into a blank CMS slot.
const isNextNavigationError = error =>
  typeof error?.digest === 'string' &&
  (error.digest.startsWith('NEXT_HTTP_ERROR_FALLBACK') ||
    error.digest.startsWith('NEXT_REDIRECT'));

class CMSComponentErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    if (isNextNavigationError(error)) {
      throw error;
    }
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (isNextNavigationError(error)) {
      throw error;
    }

    const { componentName, path } = this.props;
    logError(
      error,
      {
        component: 'CMSComponentErrorBoundary',
        cmsComponent: componentName,
        cmsPath: path,
      },
      { componentStack: info?.componentStack }
    );
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

CMSComponentErrorBoundary.propTypes = {
  children: PropTypes.node,
  componentName: PropTypes.string,
  path: PropTypes.string,
};

export default CMSComponentErrorBoundary;
